export function validateZipcode(value) {
    const length = value.length;
    if( length < 1 ) {
        return {
            value : value,
            isValid : false,
            message : "Error: Please enter your Zip/Postal Code."
        }
    }
    else if (length > 10) {
        return {
            value : value,
            isValid : false,
            message : "Error: Zip/Postal Code cannot exceed 10 characters in length."
        }
    }
    else if (length >= 1 && length <= 20) {
        // const LIMITED_TEXT_PATTERN = /^([\w-\.](\s)?)*$/; // Unnecessary escape character: \.
        const LIMITED_TEXT_PATTERN = /^([\w-.](\s)?)*$/;
        let matches = LIMITED_TEXT_PATTERN.test(value);
        if(!matches) {
            return {
                value : value,
                isValid : false,
                message : "Error: Please enter alphanumeric characters in English only. Use only spaces, hyphens, period, and underscores (no commas). Enter no more than one space between characters."
            }
        } else {
            return {
                value : value,
                isValid : true,
                message : ""
            }
        }
    }
}

export default validateZipcode;


// WEBPACK FOOTER //
// ./src/helper/validateZipcode.js